@if (loading) {
  <div class="text-center pt-5">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
<!-- <ng-container *ngIf="!loading">
<div class="row g-4 mb-3">
  <div class="col-sm-auto">
    <div>
      <a routerLink="/templates/create" class="btn btn-success">
        <i class="ri-add-line align-bottom me-1"></i> Add New
      </a>
    </div>
  </div>
  <div class="col-sm">
    <div class="d-flex justify-content-sm-end gap-2">
      <div class="search-box ms-2">
        <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchText" (ngModelChange)="onSearch()">
        <i class="ri-search-line search-icon"></i>
      </div>
    </div>
  </div>
</div>
<div *ngIf="questionnaireTemplates.length === 0" class="row">
  <div class="col-12 text-center">
    <h3 class="text-muted">No templates has been found</h3>
  </div>
</div>
<div *ngIf="questionnaireTemplates.length > 0" class="row">
  <div *ngFor="let data of questionnaireTemplates" class="col-xxl-3 col-sm-6 project-card">
    <div class="card">
      <div class="card-body">
        <div class="p-3 mt-n3 mx-n3 bg-info-subtle text-info rounded-top">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <h5 class="mb-0 fs-14">
                <a routerLink="/projects/overview" class="text-body">{{data.name}}</a>
              </h5>
            </div>
            <div class="flex-shrink-0">
              <div class="d-flex gap-1 align-items-center my-n2">
                <div class="dropdown" ngbDropdown>
                  <button class="dropdown-toggle btn btn-link text-muted p-0 text-decoration-none arrow-none" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true" ngbDropdownToggle>
                    <i class="ri-more-2-fill ri-lg align-middle"></i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                    <a class="dropdown-item" routerLink="/projects/overview">
                      <i class="ri-eye-fill align-bottom me-2 text-muted float-start"></i> View </a>
                      <a class="dropdown-item" routerLink="/projects/create">
                        <i class="ri-pencil-fill align-bottom me-2 text-muted float-start"></i> Edit </a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#removeProjectModal">
                          <i class="ri-delete-bin-fill align-bottom me-2 text-muted float-start"></i> Remove </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="py-3">
                <div class="row gy-3">
                  <div class="col-3">
                    <div>
                      <p class="text-muted mb-1">Status</p>
                      <div class="badge fs-12" [ngClass]="data.active ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'">
                        {{data.active ? 'Active' : 'Disabled'}}
                      </div>
                    </div>
                  </div>
                  <div class="col-9">
                    <div>
                      <p class="text-muted mb-1">Last Update</p>
                      <h5 class="fs-14">{{data.updatedAt === data.createdAt ? 'No Update' : data.updatedAt | date:'medium'}}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div class="py-3">
                <div class="row gy-3">
                  <div class="col-12">
                    <div>
                      <p class="text-muted mb-1">Description</p>
                      <p class="text-muted text-truncate-three-lines mb-3">{{data.description}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="questionnaireTemplates && questionnaireTemplates.length > 0" class="row justify-content-md-between align-items-md-center">
        <div class="col col-sm-6">
          <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite"> Showing {{startIndex}} to {{endIndex}} of {{total}} entries </div>
        </div>
        <div class="col col-sm-6">
          <div class="text-sm-right float-end listjs-pagination">
            <ngb-pagination [collectionSize]="total" [(page)]="currentPage" [pageSize]="pageSize"></ngb-pagination>
          </div>
        </div>
      </div>
    </ng-container> -->

    @if (!loading) {
      <div class="text-center">
        <h1 class="text-warning">COMING SOON</h1>
        <p class="text-muted">We need to decide on a design for this page first, and what to show on it.</p>
      </div>
    }